function formatZuerbellProductDescription() {
  const recognizedTitles = [
    'highlights',
    'product highlights',
    'specifications',
    'product specifications',
    'product details',
    'faq',
    'frequently asked questions'
  ];

  const headings = Array.from(document.querySelectorAll('h2')).filter((heading) =>
    recognizedTitles.includes(heading.textContent.trim().toLowerCase())
  );

  headings.forEach((heading) => {
    if (heading.closest('.zuerbell-description-card')) return;

    const container = heading.parentElement;
    if (!container) return;

    const card = document.createElement('section');
    card.className = 'zuerbell-description-card';

    const title = heading.textContent.trim().toLowerCase();

    if (title.includes('highlight')) {
      card.classList.add('zuerbell-description-card--highlights');
    } else if (
      title === 'specifications' ||
      title === 'product specifications' ||
      title === 'product details'
    ) {
      card.classList.add('zuerbell-description-card--specifications');
    } else {
      card.classList.add('zuerbell-description-card--faq');
    }

    container.insertBefore(card, heading);

    let currentElement = heading;

    while (currentElement) {
      const nextElement = currentElement.nextSibling;

      if (
        currentElement !== heading &&
        currentElement.nodeType === Node.ELEMENT_NODE &&
        currentElement.tagName === 'H2' &&
        recognizedTitles.includes(
          currentElement.textContent.trim().toLowerCase()
        )
      ) {
        break;
      }

      card.appendChild(currentElement);
      currentElement = nextElement;
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    formatZuerbellProductDescription
  );
} else {
  formatZuerbellProductDescription();
}

document.addEventListener(
  'shopify:section:load',
  formatZuerbellProductDescription
);